import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Store, Building2, Leaf } from 'lucide-react'; // Building2, Store, Leaf = outline

class CategoryV1 extends Component {

    render() {
        let publicUrl = process.env.PUBLIC_URL + '/'
        let imagealt = 'image'

        return (
            <div id='commodites' className="ltn__category-area ltn__product-gutter section-bg-1--- pt-115 pb-90 go-top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title-area ltn__section-title-2--- text-center">
                                <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">Nos Commodités</h6>
                                <h1 className="section-title">Confort & Services du Bâtiment</h1>
                            </div>
                        </div>
                    </div>
                    <div className="row ltn__category-slider-active--- slick-arrow-1 justify-content-center">
                        {/* Parking sécurisé */}
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                            <div className="ltn__category-item ltn__category-item-5 text-center">
                                <Link >
                                    <span className="category-icon"><i className="flaticon-car" /></span>
                                    <span className="category-title">Parking <br/>sécurisé</span>
                                    
                                </Link>
                            </div>
                        </div>
                        {/* Sécurité 24h/24 */}
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                            <div className="ltn__category-item ltn__category-item-5 text-center">
                                <Link >
                                    <span className="category-icon"><i className="flaticon-secure-shield" /></span>
                                    <span className="category-title">Conciergerie<br/> 24h/24h</span>
                                    
                                </Link>
                            </div>
                        </div>
                        {/* Centre médical de proximité */}
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                            <div className="ltn__category-item ltn__category-item-5 text-center">
                                <Link >
                                    <span className="category-icon"><i className="flaticon-stethoscope" /></span>
                                    <span className="category-title">Centre médical à proximité</span>
                                    
                                </Link>
                            </div>
                        </div>
                      
                        {/* Chambres spacieuses */}
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                            <div className="ltn__category-item ltn__category-item-5 text-center">
                                <Link >
                                    <span className="category-icon"><i className="flaticon-bed-1" /></span>
                                    <span className="category-title">Chambres spacieuses</span>
                                    
                                </Link>
                            </div>
                        </div>
                        {/* Domotique intégrée */}
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                            <div className="ltn__category-item ltn__category-item-5 text-center">
                                <Link >
                                    <span className="category-icon"><i className="flaticon-home-2" /></span>
                                    <span className="category-title">Domotique intégrée</span>
                                    
                                </Link>
                            </div>
                        </div>
                       
                       
<div className="col-lg-3 col-md-4 col-sm-6 col-6">
    <div className="ltn__category-item ltn__category-item-5 text-center">
        <Link >
            <span className="category-icon"><Store size={32} strokeWidth={1.5} /></span>
            <span className="category-title">Local commercial RDC</span>
        </Link>
    </div>
</div>
<div className="col-lg-3 col-md-4 col-sm-6 col-6">
    <div className="ltn__category-item ltn__category-item-5 text-center">
        <Link >
            <span className="category-icon"><Building2 size={32} strokeWidth={1.5} /></span>
            <span className="category-title">Ascenseur moderne</span>
        </Link>
    </div>
</div>
<div className="col-lg-3 col-md-4 col-sm-6 col-6">
    <div className="ltn__category-item ltn__category-item-5 text-center">
        <Link >
            <span className="category-icon"><Leaf size={32} strokeWidth={1.5} /></span>
            <span className="category-title">Espaces verts & terrasse</span>
        </Link>
    </div>
</div>

                    </div>
                </div>
            </div>
        )
    }
}

export default CategoryV1;
